import styles from "../../style/components/container.scss?inline";

export default function getClass(className) {
  return styles && styles[className] ? styles[className] : className;
}
